import { useLayoutEffect, useRef } from 'react';
import '../styles/launch-screen.css';

type Props = {
  onComplete?: () => void;
};

export default function LaunchScreen({ onComplete }: Props) {
  const screen = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    if (!onComplete || !screen.current) return;
    const host = screen.current;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      const timeout = window.setTimeout(onComplete, 0);
      return () => window.clearTimeout(timeout);
    }
    host.classList.add('launch-screen--entering');
    const timeout = window.setTimeout(onComplete, 1820);
    return () => {
      window.clearTimeout(timeout);
      host.classList.remove('launch-screen--entering');
    };
  }, [onComplete]);

  return <main ref={screen} className={`launch-screen${onComplete ? ' launch-screen--overlay' : ''}`}
    role={onComplete ? undefined : 'status'} aria-label={onComplete ? undefined : '正在載入你的單字'}
    aria-hidden={onComplete ? true : undefined}>
    <div className="launch-stage">
      <span className="launch-mark">
        <img src="/brand/woriva-w.png" alt="" />
        <img className="launch-glint" src="/brand/woriva-w.png" alt="" />
      </span>
      <span className="launch-word"><img src="/brand/woriva-wordmark.png" alt="" /></span>
    </div>
  </main>;
}
